// extracted by mini-css-extract-plugin
export default {"cardMedia":"customCard_cardMedia__04pOy","card":"customCard_card__JuXzw","cardContent":"customCard_cardContent__DxxvX"};